export const LOCALES = {
    ENGLISH: 'en-us',
    FRENCH: 'fr-fr'
};
